/* eslint-disable max-len */

import React from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '../../config/routes';

const INFORMATION_ICON = require('./information.svg');

/**
 * @return {*}
 * @constructor
 */
const SubscriptionExpiryMessage = () => (
  <div className="message">
    <span className="message__addon">
      <img src={INFORMATION_ICON} alt="Information icon" />
    </span>
    Sorry, your subscription has expired. To re-activate your subscription please navigate to your <Link to={ROUTES.SETTINGS.MEMBERSHIP}>My Membership</Link> tab.
  </div>
);

export default SubscriptionExpiryMessage;



// WEBPACK FOOTER //
// ./src/components/SubscriptionExpiryMessage/index.js